var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"myOwnOrder"},[_c('search-part'),_c('bread-crumbs',{attrs:{"crumbs":_vm.breadCrumbs}}),_c('contentWrap',[_c('div',{staticClass:"myOwnPage"},[_c('personList',{attrs:{"id":"1"}}),_c('router-view')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }